// log-icon-selected.png
import { useContext, useEffect, useState, useRef } from 'react'
import { useForm } from 'react-hook-form'
import Modal from 'react-modal'
import axios from 'axios'
import moment from 'moment'
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import { Tooltip } from 'react-tooltip';
import { useLocation } from 'react-router-dom'

import { projectContext, loadingContext, unfolder, urlValue, useTranslate, closeModalVw, openModalVw } from '../lib'
import ModalVw, { ModalBody, ModalContent, ModalHeader } from '../components/common/ModalVw'
import SideBar from '../components/SideBar'
import SideBarGenAI from '../components/ProjectGenAI/SideBarGenAI';

import { customModal } from '../styles/customModal'
import '../styles/report.scss'
import '../styles/general.scss'
import TitleBar from "../components/TitleBar";
import { useParams } from 'react-router-dom'
export default function ReportLogs(props) {
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [clients, setClients] = useState([])
  const [logs, setLogs] = useState([]);
  const [screen, setScreen] = useState(1)
  const [modalRep, setModalRep] = useState(false)
  const [description, setDescription] = useState('')
  const params = useParams();
  const [isModalOpen, setIsModalOpen] = useState({
    delete: false,
    new: false,
    edit: false,
  })
  const [refresh, setRefresh] = useState(false)
  const [selectedClient, setSelectedClient] = useState()
  const ref = useRef(null)
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useContext(loadingContext)
  const category = useRef();
  const from = useRef();
  const to = useRef();
  const { t } = useTranslate();
  const location = useLocation();
  const isGenAI = location.pathname.includes('GenAI') || location.pathname.includes('changes-logsGenAI');
  //studio/projects/logs

  const getReports = async (column, orderBy) => {
    
    try {
      let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
      let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
      let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken

      setLoading(true)
      const result = await axios.post(`${urlValue}/studio/project/logs/all`, {
        order: orderBy,
        column: column,
        "project_id": selectedProject.id,
        "user_id": '',
        "user_name": "",
        "categoria": category.current.value,
        "fechaInicial": moment(from.current.value).format('YYYY-MM-DD') + ' 00:00:00',
        "fechaFinal": moment(to.current.value).format('YYYY-MM-DD') + ' 23:59:59'
      },
        {
          headers: {
            'user': id,
            'Content-Type': 'application/json',
            'access-token': token,
            'projectid': selectedProject.id,
            'X-CSRF-Token': csrfToken
          },
          withCredentials: true,
        });

      if (result.status === 200) {
        setLogs(result.data)
      }
      setLoading(false)

    } catch (error) {
      setLoading(false)
    }

  }
  useEffect(() => {

    from.current.value = moment(new Date()).subtract('month', 1).format('YYYY-MM-DD');
    to.current.value = moment(new Date()).format('YYYY-MM-DD');
    getReports('id', 'asc');
  }, [])

  const onChange = async (e) => {
    getReports('id', 'asc');
  }

  const orderBy = async (column, e) => {

    if (e.target.classList.contains('rotar')) {
      getReports(column, 'asc');
    } else {
      getReports(column, 'desc');
    }
    e.target.classList.toggle("rotar")
    //setLogs(log)
  }

  const openModalRepprt = (text) => {
    setDescription(text)
    openModalVw("#repgeneral-modal", () => setModalRep(true))
  }

  return (
    <>
      <section className="container-answers general-container" id="container">
        {isGenAI ? <SideBarGenAI active={'Clients'} /> : <SideBar active={'Clients'} />}
        <div className="row_primary  ">
          <div className="con_title_bar">
            <TitleBar />
          </div>
          <div className="con_header">
            <div className="header">
              <div className="title">
                <div className="intents">
                  <div className="project-name-container">
                    <div className="icon"></div>
                    <h2>{selectedProject.name}</h2>
                  </div>
                  <div className="separator">-</div>
                  <div>
                    <h1>{t('menu.changesLogs')}</h1>
                  </div>

                </div>

              </div>
            </div>

          </div>


          <div className="container-info" style={{ marginTop: -50 }}>

            <div className="body-container">

              <div className='mt-5 w-full flex flex-col items-start  justify-start ' >
                <div className=' flex flex-row items-center  w-full '>
                  <div className=' flex flex-row items-center  '>
                    <div className='mr-1 label-report'>{t('intents.category')}: </div>
                    <select ref={category} onChange={onChange} id="style" className="w-100 input-data   select-nesting"
                      style={{ fontSize: 16, border: '1px solid #e3e3e3', borderRadius: 25, minWidth: 220, padding: 8 }}>
                      <option disabled selected>{t('common.select')}</option>
                      <option value="">{t('common.all')}</option>
                      <option value="Project">{t('common.project')}</option>
                      <option value="Answer">{t('common.voice')}</option>
                      <option value="Intent">{t('intent.intent')}</option>
                      <option value="Setting">{t('common.settings')}</option>
                    </select>
                  </div>

                  <div className='  flex flex-row items-center ml-5 '>
                    <div id='from-label' className='mr-2 label-report'>{t('common.from')}: </div>
                    <Tooltip style={{fontSize: 13, maxWidth: 160}}
                        anchorId="from-label" content={t('menu.selectInitialDate')} place="top" />
                    <input id="from" ref={from} onChange={onChange} type='date' className="input-nesting input-data  input-date-nesting" />
                  </div>
                  <div className='  flex flex-row items-center ml-5 ' >
                    <div id='to-label' className='mr-2 label-report'>{t('common.to')}: </div>
                    <Tooltip style={{fontSize: 13, maxWidth: 160}}
                        anchorId="to-label" content={t('menu.selectFinalDate')} place="top" />
                    <input ref={to} onChange={onChange} type='date' className="input-nesting input-data  input-date-nesting" />
                  </div>
                  <div style={{ flex: 1 }}></div>
                  <div id="search-user-input" className="ml-3 input-data p-1 bg-white d-flex flex-row align-items-center justify-space-between"
                    style={{ borderRadius: 20, backgroundColor: 'white', border: '1px solid gray', }}>
                    <input
                      type="text"
                      placeholder={t('common.search')}
                      onChange={event => {
                        setSearch(event.target.value)
                      }}
                      className=""
                      style={{ border: 'none', fontSize: 18 }}
                    />
                    <img src="/icons/search.svg" style={{ width: 18, marginRight: 10 }} />
                  </div>
                  <Tooltip style={{fontSize: 13, maxWidth: 160}}
                        anchorId="search-user-input" content={t('menu.userSearch')} place="top" />
                </div>
                <table className="table-reports mt-1">
                  <thead>
                    <tr>
                      <th> <div className='icos-th'><span>{t('common.id')}</span> <img onClick={(e) => { orderBy('id', e) }} src='/icons/icon-triengle.png' className="ml-2 img-icons-report rotate-icon" alt="icons" /></div></th>
                      <th><div className='icos-th'><span>{t('intents.category')}</span> <img onClick={(e) => { orderBy('categoria', e) }} src='/icons/icon-triengle.png' className="ml-2 img-icons-report rotate-icon" alt="icons" /></div></th>
                      <th><div className='icos-th'><span>{t('common.date')}</span> <img onClick={(e) => { orderBy('fecha', e) }} src='/icons/icon-triengle.png' className="ml-2 img-icons-report rotate-icon" alt="icons" /></div></th>
                      <th><div className='icos-th'><span>{t('common.userStudio')}</span> <img onClick={(e) => { orderBy('user_name', e) }} src='/icons/icon-triengle.png' className="ml-2 img-icons-report rotate-icon" alt="icons" /></div></th>
                      <th><div className='icos-th'><span>{t('common.description')}</span> <img onClick={(e) => { orderBy('descripcion', e) }} src='/icons/icon-triengle.png' className="ml-2 img-icons-report rotate-icon" alt="icons" /></div></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {logs.filter((x)=>(x.user_name.includes(search) || x.id.toString().includes(search))).map((item, index) => (
                      <tr>
                        <td>{item.id}</td>
                        <td>{item.categoria}</td>
                        <td style={{ minWidth: '100px' }}>{moment(item.fecha).format('YYYY-MM-DD')}</td>
                        <td>{item.user_name}</td>
                        <td> {item.descripcion.length > 60
                          ? item.descripcion.substring(0, 60) + "..."
                          : item.descripcion}
                        </td>
                        <td style={{backgroundColor: '#F7F7F7'}}>
                            <img
                                src={'/icons/view-report-icon.png'}
                                height="30"
                                alt="edit"
                                onClick={() => openModalRepprt(item.descripcion)}
                            />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* <iframe src="https://datastudio.google.com/reporting/53dfbc18-5b2d-486c-a36f-f461e3a880d7/page/kK78C?params=%7B%22df46%22:%22include%25EE%2580%25801%25EE%2580%2580IN%25EE%2580%2580120%22%7D" height="400px" width="600px"></iframe> */}



      </section>

      {modalRep ?
        <ModalVw clases="bg-[#00000061]" id="repgeneral-modal" visible={modalRep}  >
          <ModalContent styles={{ height: "60%", width: '80%' }} clases={`bg- sm:w-[80%] md:w-[80%] lg:w-[70%] xl:w-[80%] 2xl:w-1/3  w-[80%]  sm:h-[80%] md:h-[80%] lg:h-[80%] xl:h-[80%]  h-[92%] bg-white`}>
            <ModalHeader title="" onClose={() => closeModalVw("#repgeneral-modal", () => setModalRep(false))} />
            <ModalBody clases={`w-full`} >
              <div className='w-full flex flex-col items-center justify-center sticky-audio' style={{ backgroundColor: 'white' }}>
                <label className="w-full text-left mb-2">{t('common.description')}</label>
                <textarea
                  type="text"
                  id="descripcion"
                  value={description}
                  readonly
                  className="border border-gray-300 rounded px-2 py-1 text-base resize-none"
                  style={{ 
                    height: "300px",
                    width: '90%', 
                    overflowWrap: 'break-word',
                    whiteSpace: 'pre-wrap'
                  }}
                />
                <div className="btn-close-report  " onClick={() => closeModalVw("#reportcall-modal", () => setModalRep(false))}>
                  {t('common.close')}
                </div>
              </div>
            </ModalBody>
          </ModalContent>
        </ModalVw> : null}

    </>
  )
}
